import { Button } from "styled";

import Model from "components/Modal";
import { deleteDocumentById } from "apis/customApiHandler";
import { useQueryClient } from "react-query";
import toast from "react-hot-toast";
import { useLocation } from "react-router-dom";
import { saveErrorCreationEvent } from "utils/analytics";
import { ANALYTICS_EVENTS } from "utils/analyticsEvents";

const DeleteUser = ({ handleClick, id }) => {
  const queryClient = useQueryClient();
  const location = useLocation();

  function emailAlertDeleteEventFunc(eventName, params) {
    return saveErrorCreationEvent(eventName, "Delete Email Alert", "Email Alerts", location.pathname, params);
  }

  const handleClickDelete = async (id) => {
    emailAlertDeleteEventFunc(ANALYTICS_EVENTS.CLICK_DELETE_CHANGES, { deleted_email_alert_id: id });
    try {
      const data = await deleteDocumentById("email-scheduler", id);
      if (data) {
        emailAlertDeleteEventFunc(ANALYTICS_EVENTS.SYS_DELETE_EMAIL_ALERT_SUCCESS, { deleted_email_alert_id: id });
        toast.success("Successfully deleted");
        queryClient.invalidateQueries("email-scheduler");
        handleClick();
      }
    } catch (error) {
      const errMsg = error?.response?.data?.message || error?.message;
      emailAlertDeleteEventFunc(ANALYTICS_EVENTS.SYS_DELETE_EMAIL_ALERT_ERROR, { deleted_email_alert_id: id, errMsg });
    }
  };

  return (
    <Model
      handleClick={handleClick}
      title={"Delete User"}
      className="max-w-2xl"
    >
      <div className="p-4">
        <p className="text-red-500 p-5 text-center">
          Are you sure you want to delete this Email Schedule
        </p>

        <div className="px-5 flex justify-end items-center gap-4 pb-4 flex-wrap sm:w-full">
          <Button bgSecondary onClick={handleClick}>
            No
          </Button>
          <Button type="button" bgPrimary onClick={() => handleClickDelete(id)}>
            Yes
          </Button>
        </div>
      </div>
    </Model>
  );
};

export default DeleteUser;
